import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

// Modules
import RouteModule from './modules/routes';
import TablesModule from './modules/tables';
import DBModule from './modules/database';
import MessagesModule from './modules/messages';
import AuthModule from './modules/auth';
import TaxModule from './modules/tax';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    routes: {
      ...RouteModule,
    },
    tables: {
      ...TablesModule,
    },
    db: {
      ...DBModule,
    },
    auth: {
      ...AuthModule,
    },
    messages: {
      ...MessagesModule,
    },
    tax: {
      ...TaxModule,
    },
  },
});
